module.exports = __webpack_public_path__ + "img/3화_9(3).47ea6cd0.png";